import {
  MINIMUM_ATTENDEES,
  MINIMUM_GUEST_ROOMS_COUNT,
  MINIMUM_GUEST_ROOMS_COUNT_WITH_EVENT,
  NUM_UPTO_FIVE_REGEX,
} from '../constants';
import { RoomsAndEventSpaceFieldErrors, Variant } from '../molecules/RoomsAndEventSpace/RoomsAndEventSpace.types';
import { TabType } from '../organisms/SearchForm/SearchForm.types';

export const isValidNumeric = (value: string) => NUM_UPTO_FIVE_REGEX.test(value);

const isEmpty = (value: string) => value.trim() === '' || +value === 0;

const isAtLeastOneNotEmpty = (value1: string, value2: string) => {
  return !isEmpty(value1) || !isEmpty(value2);
};

export const validateAttendees = (value: string, guestRoomsValue: string, requiredError: string) => {
  return !isAtLeastOneNotEmpty(value, guestRoomsValue) ? requiredError : true;
};

export const validateGuestRooms = (
  value: string,
  attendeesValue: string,
  requiredError: string,
  minCountError: string,
  startDate?: string,
  endDate?: string,
  singleDayError?: string
) => {
  if (startDate && endDate && startDate === endDate && value && +value > 0) {
    return singleDayError;
  } else if (!isAtLeastOneNotEmpty(value, attendeesValue)) {
    return requiredError;
  } else if (+value < MINIMUM_GUEST_ROOMS_COUNT && isEmpty(attendeesValue)) {
    return minCountError;
  } else {
    return true;
  }
};

export const isValidUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
};

export const validateRoomsAndEventSpace = (
  rooms: string,
  attendees: string,
  tabType: TabType,
  errors: {
    rooms: string;
    eventSpace: string;
    roomsAndEventSpace: string;
  }
) => {
  if (tabType === TabType.ROOMS) {
    return +rooms < MINIMUM_GUEST_ROOMS_COUNT ? errors.rooms : true;
  }

  if (tabType === TabType.EVENTSPACE) {
    return +attendees < MINIMUM_ATTENDEES ? errors.eventSpace : true;
  }

  return +rooms < MINIMUM_GUEST_ROOMS_COUNT_WITH_EVENT || +attendees < MINIMUM_ATTENDEES
    ? errors.roomsAndEventSpace
    : true;
};

export const validateRoomsAndEventSpaceMobile = (
  rooms: number,
  eventAttendees: number,
  variant: Variant,
  labels: {
    guestRoomsRequiredError: string;
    guestRoomsMinCountError: string;
    attendeesRequiredError: string;
    attendeesMinCountError: string;
  }
): RoomsAndEventSpaceFieldErrors => {
  const errors: RoomsAndEventSpaceFieldErrors = {};
  const roomsStr = rooms.toString();
  const attendeesStr = eventAttendees.toString();

  if (variant === Variant.ROOMSANDEVENTSPACE) {
    const roomsError = validateGuestRooms(
      roomsStr,
      attendeesStr,
      labels.guestRoomsRequiredError,
      labels.guestRoomsMinCountError
    );
    if (roomsError !== true) errors.rooms = roomsError;

    const attendeesError = validateAttendees(attendeesStr, roomsStr, labels.attendeesMinCountError);
    if (attendeesError !== true) errors.attendees = attendeesError;
  }

  if (variant === Variant.EVENTSPACE && eventAttendees < MINIMUM_ATTENDEES) {
    errors.attendees = labels.attendeesRequiredError;
  }

  return errors;
};
